import React from "react";

const ProgressIndicator = ({ progress, label = "Processing" }) => {
  if (!progress.compressing && !progress.uploading) return null;

  const percentage = progress.total > 0 
    ? Math.round((progress.completed / progress.total) * 100)
    : 0;

  return (
    <div
      style={{
        padding: "12px",
        background: "#f4f5f8",
        borderRadius: 4,
        marginTop: 8,
        fontSize: 13,
        color: "#323338",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
        <span style={{ fontWeight: 500 }}>
          {progress.compressing ? "Compressing images..." : "Uploading images..."}
        </span>
        <span>{percentage}%</span>
      </div>
      <div
        style={{
          width: "100%",
          height: 6,
          background: "#e6e9ef",
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${percentage}%`,
            height: "100%",
            background: progress.compressing ? "#0073ea" : "#00c875",
            transition: "width 0.3s ease",
          }}
        />
      </div>
      {progress.currentFile && (
        <div
          style={{
            marginTop: 6,
            fontSize: 12,
            color: "#676879",
            fontStyle: "italic",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {progress.currentFile}
        </div>
      )}
    </div>
  );
};

export default ProgressIndicator;

